import React from 'react';
import Text from '@/presentation/text';
import Heading from '@/presentation/heading';
import { LoginRoute } from '../../common/routes';
import { useNavigate } from 'react-router-dom';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SMarginTop, SLogo, SArrowLeftIcon, STitleWrapperExt } from '../help-desk/styles/HelpDesk.styled';

const Header: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <SMarginTop />
      <SLogo>
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/billComposerCyan.svg `}
          height="80px"
          alt="CSG logo"
          id="imgBcLogo"
        />
      </SLogo>
      <STitleWrapperExt>
        <SArrowLeftIcon onClick={() => navigate(`/${(window as any).CSG_CONFIG.BASE_PATH}/${LoginRoute}`)}>
          <FontAwesomeIcon id="lnkBackToLogin" icon={faArrowLeft} title="Back to Login" size="2x" />
        </SArrowLeftIcon>
        <Heading size="l" id="idContactUs">
          Contact Us
        </Heading>
        <Text size="xxs" id="idHaveQuestions" style={{ paddingTop: '12px' }}>
          Have any questions?
        </Text>
        <Text size="xxs" id="idWeWillHelp">
          Our team is here to help you.
        </Text>
      </STitleWrapperExt>
    </>
  );
};

export default Header;
